const countryList = [
  {
    id: 101,
    code: "AD",
    name: "安道尔",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 376,
    index: "A"
  },
  {
    id: 102,
    code: "AT",
    name: "奥地利",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 43,
    index: "A"
  },
  {
    id: 103,
    code: "AL",
    name: "阿尔巴尼亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 355,
    index: "A"
  },
  {
    id: 104,
    code: "IE",
    name: "爱尔兰",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 353,
    index: "A"
  },
  {
    id: 105,
    code: "EE",
    name: "爱沙尼亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 372,
    index: "A"
  },
  {
    id: 106,
    code: "IS",
    name: "冰岛",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 354,
    index: "B"
  },
  {
    id: 107,
    code: "BY",
    name: "白俄罗斯",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 375,
    index: "B"
  },
  {
    id: 108,
    code: "BG",
    name: "保加利亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 359,
    index: "B"
  },
  {
    id: 109,
    code: "PL",
    name: "波兰",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 48,
    index: "B"
  },
  {
    id: 110,
    code: "BA",
    name: "波斯尼亚和黑塞哥维那",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 387,
    index: "B"
  },
  {
    id: 111,
    code: "BE",
    name: "比利时",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 32,
    index: "B"
  },
  {
    id: 112,
    code: "DE",
    name: "德国",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 49,
    index: "D"
  },
  {
    id: 113,
    code: "DK",
    name: "丹麦",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 45,
    index: "D"
  },
  {
    id: 114,
    code: "RU",
    name: "俄罗斯",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 7,
    index: "E"
  },
  {
    id: 115,
    code: "FR",
    name: "法国",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 33,
    index: "F"
  },
  {
    id: 116,
    code: "FI",
    name: "芬兰",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 358,
    index: "F"
  },
  {
    id: 117,
    code: "NL",
    name: "荷兰",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 31,
    index: "H"
  },
  {
    id: 118,
    code: "CZ",
    name: "捷克",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 420,
    index: "J"
  },
  {
    id: 119,
    code: "HR",
    name: "克罗地亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 385,
    index: "K"
  },
  {
    id: 120,
    code: "LV",
    name: "拉脱维亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 371,
    index: "L"
  },
  {
    id: 121,
    code: "LT",
    name: "立陶宛",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 370,
    index: "L"
  },
  {
    id: 122,
    code: "LI",
    name: "列支敦士登",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 423,
    index: "L"
  },
  {
    id: 123,
    code: "RO",
    name: "罗马尼亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 40,
    index: "L"
  },
  {
    id: 124,
    code: "MK",
    name: "马其顿",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 389,
    index: "M"
  },
  {
    id: 125,
    code: "MT",
    name: "马耳他",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 356,
    index: "M"
  },
  {
    id: 126,
    code: "LU",
    name: "卢森堡",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 352,
    index: "L"
  },
  {
    id: 127,
    code: "MC",
    name: "摩纳哥",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 377,
    index: "M"
  },
  {
    id: 128,
    code: "MD",
    name: "摩尔多瓦",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 373,
    index: "M"
  },
  {
    id: 129,
    code: "NO",
    name: "挪威",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 47,
    index: "N"
  },
  {
    id: 130,
    code: "RS",
    name: "塞尔维亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 381,
    index: "S"
  },
  {
    id: 131,
    code: "PT",
    name: "葡萄牙",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 351,
    index: "P"
  },
  {
    id: 132,
    code: "SE",
    name: "瑞典",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 46,
    index: "R"
  },
  {
    id: 133,
    code: "SZ",
    name: "斯威士兰",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 268,
    index: "S"
  },
  {
    id: 134,
    code: "SK",
    name: "斯洛伐克",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 421,
    index: "S"
  },
  {
    id: 135,
    code: "SI",
    name: "斯洛文尼亚",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 386,
    index: "S"
  },
  {
    id: 136,
    code: "SM",
    name: "圣马力诺",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 378,
    index: "S"
  },
  {
    id: 137,
    code: "UA",
    name: "乌克兰",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 380,
    index: "W"
  },
  {
    id: 138,
    code: "ES",
    name: "西班牙",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 34,
    index: "X"
  },
  {
    id: 139,
    code: "GR",
    name: "希腊",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 30,
    index: "X"
  },
  {
    id: 140,
    code: "HU",
    name: "匈牙利",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 36,
    index: "X"
  },
  {
    id: 141,
    code: "IT",
    name: "意大利",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 39,
    index: "Y"
  },
  {
    id: 142,
    code: "GB",
    name: "英国",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 44,
    index: "Y"
  },
  {
    id: 145,
    code: "XK",
    name: "科索沃",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 383,
    index: "K"
  },
  {
    id: 201,
    code: "AF",
    name: "阿富汗",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 93,
    index: "A"
  },
  {
    id: 202,
    code: "AE",
    name: "阿联酋",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 971,
    index: "A"
  },
  {
    id: 203,
    code: "OM",
    name: "阿曼",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 968,
    index: "A"
  },
  {
    id: 204,
    code: "AZ",
    name: "阿塞拜疆",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 994,
    index: "A"
  },
  {
    id: 205,
    code: "PK",
    name: "巴基斯坦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 92,
    index: "B"
  },
  {
    id: 206,
    code: "PS",
    name: "巴勒斯坦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 970,
    index: "B"
  },
  {
    id: 207,
    code: "BH",
    name: "巴林",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 973,
    index: "B"
  },
  {
    id: 208,
    code: "BT",
    name: "不丹",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 975,
    index: "B"
  },
  {
    id: 209,
    code: "KP",
    name: "朝鲜",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 850,
    index: "C"
  },
  {
    id: 210,
    code: "TL",
    name: "东帝汶",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 670,
    index: "D"
  },
  {
    id: 211,
    code: "PH",
    name: "菲律宾",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 63,
    index: "F"
  },
  {
    id: 212,
    code: "GE",
    name: "格鲁吉亚",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 995,
    index: "K"
  },
  {
    id: 213,
    code: "KZ",
    name: "哈萨克斯坦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 327,
    index: "H"
  },
  {
    id: 214,
    code: "KR",
    name: "韩国",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 82,
    index: "H"
  },
  {
    id: 215,
    code: "KG",
    name: "吉尔吉斯斯坦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 331,
    index: "J"
  },
  {
    id: 216,
    code: "KH",
    name: "柬埔寨",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 855,
    index: "J"
  },
  {
    id: 217,
    code: "QA",
    name: "卡塔尔国",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 974,
    index: "K"
  },
  {
    id: 218,
    code: "KW",
    name: "科威特",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 965,
    index: "K"
  },
  {
    id: 219,
    code: "LA",
    name: "老挝",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 856,
    index: "L"
  },
  {
    id: 220,
    code: "LB",
    name: "黎巴嫩",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 961,
    index: "L"
  },
  {
    id: 221,
    code: "MV",
    name: "马尔代夫",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 960,
    index: "M"
  },
  {
    id: 222,
    code: "MY",
    name: "马来西亚",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 60,
    index: "M"
  },
  {
    id: 223,
    code: "MN",
    name: "蒙古",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 976,
    index: "M"
  },
  {
    id: 224,
    code: "BD",
    name: "孟加拉国",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 880,
    index: "M"
  },
  {
    id: 225,
    code: "MM",
    name: "缅甸",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 95,
    index: "M"
  },
  {
    id: 226,
    code: "NP",
    name: "尼泊尔",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 977,
    index: "N"
  },
  {
    id: 227,
    code: "JP",
    name: "日本",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 81,
    index: "R"
  },
  {
    id: 228,
    code: "CY",
    name: "塞浦路斯",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 357,
    index: "S"
  },
  {
    id: 229,
    code: "SA",
    name: "沙特阿拉伯",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 966,
    index: "S"
  },
  {
    id: 230,
    code: "LK",
    name: "斯里兰卡",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 94,
    index: "S"
  },
  {
    id: 231,
    code: "TJ",
    name: "塔吉克斯坦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 992,
    index: "T"
  },
  {
    id: 232,
    code: "TH",
    name: "泰国",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 66,
    index: "T"
  },
  {
    id: 233,
    code: "TR",
    name: "土耳其",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 90,
    index: "T"
  },
  {
    id: 234,
    code: "TM",
    name: "土库曼斯坦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 993,
    index: "T"
  },
  {
    id: 235,
    code: "BN",
    name: "文莱",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 673,
    index: "W"
  },
  {
    id: 236,
    code: "UZ",
    name: "乌兹别克斯坦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 998,
    index: "W"
  },
  {
    id: 237,
    code: "SG",
    name: "新加坡",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 65,
    index: "X"
  },
  {
    id: 238,
    code: "SY",
    name: "叙利亚",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 963,
    index: "X"
  },
  {
    id: 239,
    code: "AM",
    name: "亚美尼亚",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 374,
    index: "Y"
  },
  {
    id: 240,
    code: "YE",
    name: "也门",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 967,
    index: "Y"
  },
  {
    id: 241,
    code: "IR",
    name: "伊朗",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 98,
    index: "Y"
  },
  {
    id: 242,
    code: "IQ",
    name: "伊拉克",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 964,
    index: "Y"
  },
  {
    id: 243,
    code: "IL",
    name: "以色列",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 972,
    index: "Y"
  },
  {
    id: 244,
    code: "IN",
    name: "印度",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 91,
    index: "Y"
  },
  {
    id: 245,
    code: "ID",
    name: "印度尼西亚",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 62,
    index: "Y"
  },
  {
    id: 246,
    code: "JO",
    name: "约旦",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 962,
    index: "Y"
  },
  {
    id: 247,
    code: "VN",
    name: "越南",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 84,
    index: "Y"
  },
  {
    id: 248,
    code: "CN",
    name: "中国大陆",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 86,
    index: "Z"
  },
  {
    id: 250,
    code: "TW",
    name: "中国台湾",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 886,
    index: "T"
  },
  {
    id: 251,
    code: "HK",
    name: "中国香港",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 852,
    index: "X"
  },
  {
    id: 252,
    code: "MO",
    name: "中国澳门",
    domain: "test14.ys7.com",
    region: "Asia",
    telephoneCode: 853,
    index: "A"
  },
  {
    id: 301,
    code: "AR",
    name: "阿根廷",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 54,
    index: "A"
  },
  {
    id: 302,
    code: "AG",
    name: "安提瓜和巴布达",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1268,
    index: "A"
  },
  {
    id: 303,
    code: "BB",
    name: "巴巴多斯",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1246,
    index: "B"
  },
  {
    id: 304,
    code: "BO",
    name: "玻利维亚",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 591,
    index: "B"
  },
  {
    id: 305,
    code: "BR",
    name: "巴西",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 55,
    index: "B"
  },
  {
    id: 306,
    code: "DM",
    name: "多米尼克国",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 767,
    index: "D"
  },
  {
    id: 307,
    code: "EC",
    name: "厄瓜多尔",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 593,
    index: "E"
  },
  {
    id: 308,
    code: "CU",
    name: "古巴",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 53,
    index: "G"
  },
  {
    id: 309,
    code: "CO",
    name: "哥伦比亚",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 57,
    index: "G"
  },
  {
    id: 310,
    code: "GD",
    name: "格林纳达",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 473,
    index: "G"
  },
  {
    id: 311,
    code: "GY",
    name: "圭亚那",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 592,
    index: "G"
  },
  {
    id: 312,
    code: "CA",
    name: "加拿大",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1,
    index: "J"
  },
  {
    id: 313,
    code: "PE",
    name: "秘鲁",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 51,
    index: "M"
  },
  {
    id: 314,
    code: "US",
    name: "美国",
    domain: "test15.ys7.com",
    region: "America",
    telephoneCode: 1,
    index: "M"
  },
  {
    id: 315,
    code: "MX",
    name: "墨西哥",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 52,
    index: "M"
  },
  {
    id: 316,
    code: "SR",
    name: "苏里南",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 597,
    index: "S"
  },
  {
    id: 317,
    code: "LC",
    name: "圣卢西亚",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1758,
    index: "S"
  },
  {
    id: 318,
    code: "TT",
    name: "特立尼达和多巴哥",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1868,
    index: "T"
  },
  {
    id: 319,
    code: "UY",
    name: "乌拉圭",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 598,
    index: "W"
  },
  {
    id: 320,
    code: "VE",
    name: "委内瑞拉",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 58,
    index: "W"
  },
  {
    id: 321,
    code: "JM",
    name: "牙买加",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1876,
    index: "Y"
  },
  {
    id: 322,
    code: "CL",
    name: "智利",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 56,
    index: "Z"
  },
  {
    id: 323,
    code: "BS",
    name: "巴哈马",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1242,
    index: "B"
  },
  {
    id: 326,
    code: "BZ",
    name: "伯利兹",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 501,
    index: "B"
  },
  {
    id: 327,
    code: "GT",
    name: "危地马拉",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 502,
    index: "W"
  },
  {
    id: 328,
    code: "SV",
    name: "萨尔瓦多",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 503,
    index: "S"
  },
  {
    id: 329,
    code: "HN",
    name: "洪都拉斯",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 504,
    index: "H"
  },
  {
    id: 330,
    code: "NI",
    name: "尼加拉瓜",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 505,
    index: "N"
  },
  {
    id: 331,
    code: "CR",
    name: "哥斯达黎加",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 506,
    index: "G"
  },
  {
    id: 332,
    code: "PA",
    name: "巴拿马",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 507,
    index: "B"
  },
  {
    id: 333,
    code: "BM",
    name: "百慕大群岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1441,
    index: "B"
  },
  {
    id: 334,
    code: "CW",
    name: "库拉索",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 5999,
    index: "K"
  },
  {
    id: 335,
    code: "DO",
    name: "多米尼加",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1809,
    index: "D"
  },
  {
    id: 336,
    code: "GL",
    name: "格陵兰岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 299,
    index: "G"
  },
  {
    id: 337,
    code: "GP",
    name: "瓜德罗普",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 590,
    index: "G"
  },
  {
    id: 338,
    code: "AI",
    name: "安圭拉",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1264,
    index: "A"
  },
  {
    id: 339,
    code: "AW",
    name: "阿鲁巴",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 5998,
    index: "A"
  },
  {
    id: 340,
    code: "HT",
    name: "海地",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 509,
    index: "H"
  },
  {
    id: 341,
    code: "KN",
    name: "圣基茨和尼维斯",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1869,
    index: "S"
  },
  {
    id: 342,
    code: "KY",
    name: "开曼群岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1345,
    index: "K"
  },
  {
    id: 343,
    code: "MF",
    name: "圣马丁",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 590,
    index: "S"
  },
  {
    id: 344,
    code: "SX",
    name: "圣马丁岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1721,
    index: "S"
  },
  {
    id: 345,
    code: "MQ",
    name: "马提尼克岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 596,
    index: "M"
  },
  {
    id: 346,
    code: "MS",
    name: "蒙特塞拉特",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1664,
    index: "M"
  },
  {
    id: 347,
    code: "BL",
    name: "圣巴泰勒米",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 590,
    index: "S"
  },
  {
    id: 349,
    code: "PM",
    name: "圣皮埃尔和密克隆",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 508,
    index: "S"
  },
  {
    id: 350,
    code: "PR",
    name: "波多黎各",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1787,
    index: "B"
  },
  {
    id: 351,
    code: "AQ",
    name: "南极洲",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 0,
    index: "N"
  },
  {
    id: 352,
    code: "TC",
    name: "特克斯和凯科斯群岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1649,
    index: "T"
  },
  {
    id: 353,
    code: "VC",
    name: "圣文森特和格林纳丁斯",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1784,
    index: "S"
  },
  {
    id: 354,
    code: "VG",
    name: "英属维尔京群岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1284,
    index: "Y"
  },
  {
    id: 355,
    code: "VI",
    name: "美属维京群岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 1340,
    index: "M"
  },
  {
    id: 356,
    code: "FK",
    name: "马尔维纳斯群岛",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 500,
    index: "M"
  },
  {
    id: 357,
    code: "GF",
    name: "法属圭亚那",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 594,
    index: "F"
  },
  {
    id: 358,
    code: "PY",
    name: "巴拉圭",
    domain: "test14.ys7.com",
    region: "America",
    telephoneCode: 595,
    index: "B"
  },
  {
    id: 401,
    code: "DZ",
    name: "阿尔及利亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 213,
    index: "A"
  },
  {
    id: 402,
    code: "EG",
    name: "埃及",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 20,
    index: "A"
  },
  {
    id: 403,
    code: "ET",
    name: "埃塞俄比亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 251,
    index: "A"
  },
  {
    id: 404,
    code: "AO",
    name: "安哥拉",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 244,
    index: "A"
  },
  {
    id: 405,
    code: "BJ",
    name: "贝宁",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 229,
    index: "B"
  },
  {
    id: 406,
    code: "BW",
    name: "博茨瓦纳",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 267,
    index: "B"
  },
  {
    id: 407,
    code: "BF",
    name: "布基纳法索",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 226,
    index: "B"
  },
  {
    id: 408,
    code: "BI",
    name: "布隆迪共和国",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 257,
    index: "B"
  },
  {
    id: 409,
    code: "GQ",
    name: "赤道几内亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 240,
    index: "C"
  },
  {
    id: 410,
    code: "TG",
    name: "多哥",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 228,
    index: "D"
  },
  {
    id: 411,
    code: "ER",
    name: "厄立特里亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 291,
    index: "E"
  },
  {
    id: 412,
    code: "CV",
    name: "佛得角",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 238,
    index: "F"
  },
  {
    id: 413,
    code: "GM",
    name: "冈比亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 220,
    index: "G"
  },
  {
    id: 414,
    code: "CG",
    name: "刚果共和国",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 242,
    index: "G"
  },
  {
    id: 415,
    code: "CD",
    name: "刚果民主共和国",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 243,
    index: "G"
  },
  {
    id: 416,
    code: "DJ",
    name: "吉布提",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 253,
    index: "J"
  },
  {
    id: 417,
    code: "GN",
    name: "几内亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 224,
    index: "J"
  },
  {
    id: 418,
    code: "GW",
    name: "几内亚比绍共和国",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 245,
    index: "J"
  },
  {
    id: 419,
    code: "GA",
    name: "加蓬",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 241,
    index: "J"
  },
  {
    id: 420,
    code: "GH",
    name: "加纳",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 233,
    index: "J"
  },
  {
    id: 421,
    code: "ZW",
    name: "津巴布韦",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 263,
    index: "J"
  },
  {
    id: 422,
    code: "CM",
    name: "喀麦隆",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 237,
    index: "K"
  },
  {
    id: 423,
    code: "KM",
    name: "科摩罗",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 269,
    index: "K"
  },
  {
    id: 424,
    code: "CI",
    name: "科特迪瓦",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 225,
    index: "K"
  },
  {
    id: 425,
    code: "KE",
    name: "肯尼亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 254,
    index: "K"
  },
  {
    id: 426,
    code: "LS",
    name: "莱索托",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 266,
    index: "L"
  },
  {
    id: 427,
    code: "LR",
    name: "利比里亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 231,
    index: "L"
  },
  {
    id: 428,
    code: "LY",
    name: "利比亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 218,
    index: "L"
  },
  {
    id: 429,
    code: "RW",
    name: "卢旺达",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 250,
    index: "L"
  },
  {
    id: 430,
    code: "MG",
    name: "马达加斯加",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 261,
    index: "M"
  },
  {
    id: 431,
    code: "ML",
    name: "马里",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 223,
    index: "M"
  },
  {
    id: 432,
    code: "MU",
    name: "毛里求斯",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 230,
    index: "M"
  },
  {
    id: 433,
    code: "MR",
    name: "毛利塔尼亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 222,
    index: "M"
  },
  {
    id: 434,
    code: "MA",
    name: "摩洛哥",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 212,
    index: "M"
  },
  {
    id: 435,
    code: "MZ",
    name: "莫桑比克",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 258,
    index: "M"
  },
  {
    id: 436,
    code: "NA",
    name: "纳米比亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 264,
    index: "N"
  },
  {
    id: 437,
    code: "ZA",
    name: "南非",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 27,
    index: "N"
  },
  {
    id: 438,
    code: "NE",
    name: "尼日尔",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 227,
    index: "N"
  },
  {
    id: 439,
    code: "NG",
    name: "尼日利亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 234,
    index: "N"
  },
  {
    id: 440,
    code: "SL",
    name: "塞拉利昂",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 232,
    index: "S"
  },
  {
    id: 441,
    code: "SN",
    name: "塞内加尔",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 221,
    index: "S"
  },
  {
    id: 442,
    code: "SC",
    name: "塞舌尔",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 248,
    index: "S"
  },
  {
    id: 443,
    code: "ST",
    name: "圣多美和普林西比",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 239,
    index: "S"
  },
  {
    id: 444,
    code: "SD",
    name: "苏丹",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 249,
    index: "S"
  },
  {
    id: 445,
    code: "SO",
    name: "索马里",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 252,
    index: "S"
  },
  {
    id: 446,
    code: "TZ",
    name: "坦桑尼亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 255,
    index: "T"
  },
  {
    id: 447,
    code: "TN",
    name: "突尼斯",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 216,
    index: "T"
  },
  {
    id: 448,
    code: "UG",
    name: "乌干达",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 256,
    index: "W"
  },
  {
    id: 449,
    code: "ZM",
    name: "赞比亚",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 260,
    index: "Z"
  },
  {
    id: 450,
    code: "TD",
    name: "乍得",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 235,
    index: "Z"
  },
  {
    id: 451,
    code: "CF",
    name: "中非共和国",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 236,
    index: "Z"
  },
  {
    id: 453,
    code: "MW",
    name: "马拉维",
    domain: "test14.ys7.com",
    region: "Africa",
    telephoneCode: 265,
    index: "M"
  },
  {
    id: 501,
    code: "AU",
    name: "澳大利亚",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 61,
    index: "A"
  },
  {
    id: 502,
    code: "PG",
    name: "巴布亚新几内亚独立国",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 675,
    index: "B"
  },
  {
    id: 503,
    code: "FJ",
    name: "斐济",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 679,
    index: "F"
  },
  {
    id: 504,
    code: "CK",
    name: "库克群岛",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 682,
    index: "K"
  },
  {
    id: 505,
    code: "WS",
    name: "萨摩亚",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 685,
    index: "S"
  },
  {
    id: 506,
    code: "FM",
    name: "密克罗尼西亚",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 691,
    index: "M"
  },
  {
    id: 507,
    code: "NR",
    name: "瑙鲁",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 674,
    index: "N"
  },
  {
    id: 508,
    code: "TO",
    name: "汤加",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 675,
    index: "T"
  },
  {
    id: 509,
    code: "VU",
    name: "瓦努阿图",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 678,
    index: "N"
  },
  {
    id: 510,
    code: "NZ",
    name: "新西兰",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 64,
    index: "X"
  },
  {
    id: 512,
    code: "CH",
    name: "瑞士",
    domain: "test14.ys7.com",
    region: "Europe",
    telephoneCode: 41,
    index: "R"
  },
  {
    id: 513,
    code: "AX",
    name: "奥兰群岛",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 358,
    index: "A"
  },
  {
    id: 514,
    code: "AC",
    name: "阿森松岛",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 247,
    index: "A"
  },
  {
    id: 515,
    code: "AS",
    name: "美属萨摩亚群岛",
    domain: "test14.ys7.com",
    region: "Oceania",
    telephoneCode: 684,
    index: "M"
  }
];
exports.countryList = countryList;
exports.changeNameToCode = (name = "China") => {
  return name.split("&")[1];
};
